/* src/components/Toolbar/components/StrokeColor.svelte generated by Svelte v3.54.0 */
import {
	SvelteComponent,
	append,
	attr,
	destroy_block,
	detach,
	element,
	init,
	insert,
	listen,
	noop,
	safe_not_equal,
	set_style,
	space,
	subscribe,
	toggle_class,
	update_keyed_each
} from "svelte/internal";

import { colorKeys, colors } from "./constants";

function get_each_context(ctx, list, i) {
	const child_ctx = ctx.slice();
	child_ctx[7] = list[i];
	return child_ctx;
}

// (25:2) {#each colorKeys as key (key)}
function create_each_block(key_1, ctx) {
	let button;
	let span;
	let t;
	let button_class_value;
	let button_data_color_key_value;

	return {
		key: key_1,
		first: null,
		c() {
			button = element("button");
			span = element("span");
			t = space();
			attr(span, "class", "fastboard-toolbar-color-item");
			set_style(span, "background-color", /*key*/ ctx[7]);
			attr(button, "class", button_class_value = "fastboard-toolbar-btn fastboard-toolbar-color-btn " + /*theme*/ ctx[0]);
			attr(button, "data-color-key", button_data_color_key_value = /*key*/ ctx[7]);
			button.disabled = /*disabled*/ ctx[1];
			toggle_class(button, "is-active", is_equal_color(/*strokeColor*/ ctx[2], colors[/*key*/ ctx[7]]));
			this.first = button;
		},
		m(target, anchor) {
			insert(target, button, anchor);
			append(button, span);
			append(button, t);
		},
		p(new_ctx, dirty) {
			ctx = new_ctx;

			if (dirty & /*theme*/ 1 && button_class_value !== (button_class_value = "fastboard-toolbar-btn fastboard-toolbar-color-btn " + /*theme*/ ctx[0])) {
				attr(button, "class", button_class_value);
			}

			if (dirty & /*disabled*/ 2) {
				button.disabled = /*disabled*/ ctx[1];
			}

			if (dirty & /*theme, is_equal_color, strokeColor, colors, colorKeys*/ 5) {
				toggle_class(button, "is-active", is_equal_color(/*strokeColor*/ ctx[2], colors[/*key*/ ctx[7]]));
			}
		},
		d(detaching) {
			if (detaching) detach(button);
		}
	};
}

function create_fragment(ctx) {
	let div;
	let each_blocks = [];
	let each_1_lookup = new Map();
	let div_class_value;
	let mounted;
	let dispose;
	let each_value = colorKeys;
	const get_key = ctx => /*key*/ ctx[7];

	for (let i = 0; i < each_value.length; i += 1) {
		let child_ctx = get_each_context(ctx, each_value, i);
		let key = get_key(child_ctx);
		each_1_lookup.set(key, each_blocks[i] = create_each_block(key, child_ctx));
	}

	return {
		c() {
			div = element("div");

			for (let i = 0; i < each_blocks.length; i += 1) {
				each_blocks[i].c();
			}

			attr(div, "class", div_class_value = "fastboard-toolbar-colors " + /*theme*/ ctx[0]);
		},
		m(target, anchor) {
			insert(target, div, anchor);

			for (let i = 0; i < each_blocks.length; i += 1) {
				each_blocks[i].m(div, null);
			}

			if (!mounted) {
				dispose = listen(div, "click", /*set_stroke_color*/ ctx[4]);
				mounted = true;
			}
		},
		p(ctx, [dirty]) {
			if (dirty & /*theme, colorKeys, disabled, is_equal_color, strokeColor, colors*/ 7) {
				each_value = colorKeys;
				each_blocks = update_keyed_each(each_blocks, dirty, get_key, 1, ctx, each_value, each_1_lookup, div, destroy_block, create_each_block, null, get_each_context);
			}

			if (dirty & /*theme*/ 1 && div_class_value !== (div_class_value = "fastboard-toolbar-colors " + /*theme*/ ctx[0])) {
				attr(div, "class", div_class_value);
			}
		},
		i: noop,
		o: noop,
		d(detaching) {
			if (detaching) detach(div);

			for (let i = 0; i < each_blocks.length; i += 1) {
				each_blocks[i].d();
			}

			mounted = false;
			dispose();
		}
	};
}

function is_equal_color(a, b) {
	return a && b && a.every((v, i) => v === b[i]);
}

function instance($$self, $$props, $$invalidate) {
	let memberState;
	let strokeColor;

	let $memberState,
		$$unsubscribe_memberState = noop,
		$$subscribe_memberState = () => ($$unsubscribe_memberState(), $$unsubscribe_memberState = subscribe(memberState, $$value => $$invalidate(6, $memberState = $$value)), memberState);

	$$self.$$.on_destroy.push(() => $$unsubscribe_memberState());
	let { app = null } = $$props;
	let { theme = "light" } = $$props;
	let { disabled = false } = $$props;

	function set_stroke_color(ev) {
		let button = ev.target;

		if (button && button.dataset.colorKey) {
			let color = colors[button.dataset.colorKey];

			if (color && app) {
				app.setStrokeColor(color);
			}
		}
	}

	$$self.$$set = $$props => {
		if ('app' in $$props) $$invalidate(5, app = $$props.app);
		if ('theme' in $$props) $$invalidate(0, theme = $$props.theme);
		if ('disabled' in $$props) $$invalidate(1, disabled = $$props.disabled);
	};

	$$self.$$.update = () => {
		if ($$self.$$.dirty & /*app*/ 32) {
			$: $$subscribe_memberState($$invalidate(3, memberState = app?.memberState));
		}

		if ($$self.$$.dirty & /*$memberState*/ 64) {
			$: $$invalidate(2, strokeColor = $memberState?.strokeColor);
		}
	};

	return [theme, disabled, strokeColor, memberState, set_stroke_color, app, $memberState];
}

class StrokeColor extends SvelteComponent {
	constructor(options) {
		super();
		init(this, options, instance, create_fragment, safe_not_equal, { app: 5, theme: 0, disabled: 1 });
	}
}

export default StrokeColor;